import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useArticles } from '../hooks/articles';
import { siteConfig } from '../siteData';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { formatArticleDate } from '../utils/articleDate';
import LoadingSpinner from '../components/LoadingSpinner';
import '../App.css';
import './Articles.css';

function Articles() {
  const navigate = useNavigate();
  const { data: articles, isLoading, isFetching, error } = useArticles();

  // Use articles from API or fallback to static data
  const displayArticles = Array.isArray(articles) && articles.length > 0 ? articles : siteConfig.featuredStories;
  
  // Get featured article (first one) and rest of articles
  const featuredArticle = displayArticles[0];
  const gridArticles = displayArticles.slice(1);

  return (
    <div className="App blog-page">
      <Header />

      {/* Main Content */}
      <main className="blog-main">  
        {/* Blog Header */}
        {/* <div className="blog-header">
          <span className="blog-label">○ Blog</span>
        </div> */}

        {isLoading && (
          <>
            <LoadingSpinner className="loading-indicator-compact" />
            <div className="blog-grid" aria-hidden="true">
              {Array.from({ length: 6 }, (_, index) => (
                <div className="blog-card blog-card-skeleton" key={index}>
                  <div className="blog-card-image article-skeleton-block" />
                  <div className="blog-card-content">
                    <div className="article-skeleton-block article-skeleton-date" />
                    <div className="article-skeleton-block article-skeleton-title" />
                    <div className="article-skeleton-block article-skeleton-line" />
                    <div className="article-skeleton-block article-skeleton-line article-skeleton-short" />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {!isLoading && isFetching && (
          <LoadingSpinner className="loading-indicator-compact" label="Шинэчилж байна...." />
        )}
        {error && <p style={{ textAlign: 'center', padding: '2rem', color: 'red' }}>Error loading articles. Showing default content.</p>}
        
        {!isLoading && featuredArticle && (
          <>
            {/* Featured Article */}
            {/* <article 
              className="blog-featured"
              onClick={() => navigate(`/article/${featuredArticle.id}`)}
            >
              <div className="blog-featured-content">
                <span className="blog-date">{formatArticleDate(featuredArticle) || featuredArticle.category}</span>
                <h1 className="blog-featured-title">{featuredArticle.title}</h1>
                <p className="blog-featured-excerpt">{featuredArticle.excerpt}</p>
                <div className="blog-author">
                  <div className="blog-author-avatar">
                    <img src={featuredArticle.authorImage || "https://ui-avatars.com/api/?name=Author&background=random"} alt="Author" />
                  </div>
                  <div className="blog-author-info">
                    <span className="blog-author-name">{featuredArticle.author || 'Author'}</span>
                    <span className="blog-author-role">{featuredArticle.authorRole || 'Writer'}</span>
                  </div>
                </div>
              </div>
              <div className="blog-featured-image">
                <img src={featuredArticle.asset || featuredArticle.image} alt={featuredArticle.title} />
              </div>
            </article> */}

            {/* Articles Grid */}
            <div className="blog-grid">
              {gridArticles.map((story) => (
                <article 
                  key={story.id} 
                  className="blog-card"
                  onClick={() => navigate(`/article/${story.id}`)}
                >
                  <div className="blog-card-image">
                    <img src={story.asset || story.image} alt={story.title} />
                  </div>
                  <div className="blog-card-content">
                    <span className="blog-date">
                      {[
                        formatArticleDate(story),
                        story.category?.split(',').map(category => category.trim()).filter(Boolean).join(', ')
                      ].filter(Boolean).join(' | ')}
                    </span>
                    <h3 className="blog-card-title">{story.title}</h3>
                    <p className="blog-card-excerpt">{story.excerpt}</p>
                  </div>
                </article>
              ))}
            </div>
          </>
        )}
      </main>

      <Footer />
    </div>
  );
}

export default Articles;
